<!-- <div class="form-page-wrapper"> -->
<div class="container container form-page-placement">
    <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block container-padding">
        <div class="row" >
            <div *ngIf="captureSuccess" class="col-xs-12 bottom-spc-20">
                <div class="col-xs-5 col-xs-offset-3 col-md-3 col-md-offset-4">
                    <img class="loan-confirm-img img-responsive" src="./assets/img/svg/loan_commercials-01.svg">
                </div>
            </div>
            <div *ngIf="captureSuccess && consentType === 'APPROVAL_MAIL'" class="col-xs-12 bottom-spc-20">
                <h2 class="heading-style bottom-spc-10 col-xs-12 text-center" > {{this.successMessage}} </h2>
            </div>
            <div *ngIf="captureSuccess && consentType !== 'APPROVAL_MAIL'" class="col-xs-12 bottom-spc-20">
                <h2 class="heading-style bottom-spc-10 col-xs-12 text-center" > {{approveSuccessMsg}} </h2>
                <div class="col-xs-12 text-center" >Our sales representative will get in touch with you if any further action is required.</div>
            </div>
            <div *ngIf="isBusinessError"  class="col-xs-12 bottom-spc-20">
                <div class="col-xs-5 col-xs-offset-3 col-md-3 col-md-offset-4">
                    <img class="loan-confirm-img img-responsive" src="./assets/img/svg/loan_commercials-01.svg">
                </div>
                <h2 class="heading-style bottom-spc-10 col-xs-12 text-center"> {{errorMessage}}</h2>
                <div class="col-xs-12 text-center" *ngIf="consentType !== 'APPROVAL_MAIL'">Our sales representative will get in touch with you if any further action is required.</div>
            </div>
            <div *ngIf="isError" class="col-xs-12 bottom-spc-20 text-center">
                <img class="loan-confirm-img" src="./assets/img/svg/loan_commercials-02.svg">

                <h2 class="heading-style bottom-spc-10"> Unable to process your request</h2>
                <div *ngIf="consentType !== 'APPROVAL_MAIL'">Our sales representative will get in touch with you if any further action is required.</div>
            </div>
        </div>

        <div *ngIf="capturePricingData">
            <div>Hi {{pricingData.name}}</div>
            <div>Please find your Loan details </div>

            <div class="form-container">
                <div class="pricing-details">
                    <div class="pricing-details-left-div text-bold">Application ID</div>
                    <div class="pricing-details-right-div text-bold">: {{pricingData.parentApplicationKey}}</div> 
                    <!-- {{applicationId}} -->
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Loan Amount</div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.finalLoanAmount}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Rate of Interest (p.a.)</div>
                    <div class="pricing-details-right-div text-bold">: {{pricingData.finalRoi | number: '1.2-2'}} %</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Method of Interest Calculation</div>
                    <div class="pricing-details-right-div text-bold">: Reducing rate of Interest</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Type of Interest rate</div>
                    <div class="pricing-details-right-div text-bold">: Fixed</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Tenure </div>
                    <div class="pricing-details-right-div text-bold">: {{(pricingData.tenureIs+pricingData.tenureDropline)/12}} Years</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Loan Type </div>
                    <div class="pricing-details-right-div text-bold">: {{pricingData.l4ProductTypeDesc}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div text-bold">EMI on full utilization of amount </div>
                    <!-- <div class="pricing-details-right-div text-bold">: {{pricingData.emiAmount}}</div> -->
                </div>
                <!-- <div class="pricing-details">
                    <div class="pricing-details-left-div">First EMI*** </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.emiAmount}}</div>
                </div> -->
                <div class="pricing-details" *ngIf="!termLoan">
                    <div class="pricing-details-left-div">EMI - First {{pricingData.tenureIs}} months*** </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.emiIs}}</div>
                </div>
                <div class="pricing-details" *ngIf="!termLoan">
                    <div class="pricing-details-left-div">EMI - Next {{pricingData.tenureDropline}} months </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.emiDropline}}</div>
                </div>
                <div class="pricing-details" *ngIf="termLoan">
                    <div class="pricing-details-left-div">EMI amount*** </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.emiDropline}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">EMI cycle date </div>
                    <div class="pricing-details-right-div text-bold">: {{pricingData.emiCycleDay}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">First EMI date </div>
                    <div class="pricing-details-right-div text-bold">: {{pricingData.firstEmiDueDate | date : 'dd-MM-yyyy'}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div text-bold">Fees and charges </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{totalFeeAndCharges}}</div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Processing Fees (inclusive of applicable taxes) </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{procfee}}</div>
                </div>
                <!-- <div class="pricing-details">
                    <div class="pricing-details-left-div">Convenience Fees (inclusive of applicable taxes) </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{convfee}}</div>
                </div> -->
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Stamp Fee </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{stampfee}}</div>
                </div>
                <div class="pricing-details" *ngIf="pricingData.bundleSelectedFlag">
                    <div class="pricing-details-left-div">{{pricingData.bundleApplicationPlanName}} (inclusive of applicable taxes) </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.bundleamount}}</div>
                </div>
                <div class="pricing-details" *ngIf="flexifeeflag">
                    <div class="pricing-details-left-div">Flexi Fee (inclusive of applicable taxes) </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{flexifee}}</div>
                </div>
                <div class="pricing-details" *ngIf="amcFlag">
                    <div class="pricing-details-left-div">Annual Maintenance Charge (inclusive of applicable taxes) </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{amcfee}}</div>
                </div>
                <div class="pricing-section" *ngIf="bundleSelection" style="margin-top: 6px;">
                    <div>To know more click</div>
                    <div *ngIf="fppLite">
                        <a href="https://www.bajajfinservmarkets.in/markets-loan-shield"  style="color: #0074c9">https://www.bajajfinservmarkets.in/markets-loan-shield</a>
                    </div>
                    <div *ngIf="fppRequired">
                        <a href="https://www.bajajfinservmarkets.in/markets-loan-shield"  style="color: #0074c9">https://www.bajajfinservmarkets.in/markets-loan-shield</a>
                    </div>
                    <div *ngIf="!fppLite && !fppRequired">
                        <a href="https://www.bajajfinservmarkets.in/markets-loan-shield"  style="color: #0074c9">https://www.bajajfinservmarkets.in/markets-loan-shield</a>
                    </div>
                </div>
                <div class="pricing-details">
                    <div class="pricing-details-left-div">Net Disbursement Amount </div>
                    <div class="pricing-details-right-div text-bold">: ₹ {{pricingData.netDisbursementAmt}}</div>
                </div>
                <div class="pricing-details" *ngIf="pricingData.l4ProductTypeDesc !== 'Bajaj Finance Term Loan(MFI)'">
                    <div class="pricing-details-left-div">Part Payment Charges </div>
                    <div class="pricing-details-right-div text-bold" *ngIf="!termLoan">: NIL</div>
                    <div class="pricing-details-right-div text-bold" *ngIf="termLoan">: 4.72% (Inclusive of applicable
                        taxes) on part pre-payment amount paid</div>
                </div>
                <div class="pricing-details" *ngIf="pricingData.l4ProductTypeDesc !== 'Bajaj Finance Term Loan(MFI)'">
                    <div class="pricing-details-left-div">Foreclosure Charges </div>
                    <div class="pricing-details-right-div text-bold">: 4.72% (Inclusive of applicable taxes) on the outstanding loan amount as on the date of full pre-payment</div>
                </div>
                <div class="pricing-details" *ngIf="!termLoan">
                    <div class="pricing-details-left-div">Annual Maintenance Charges </div>
                    <div class="pricing-details-right-div text-boldt">
                        <div><strong>Initial Tenure: </strong> {{pricingData.initialTenurePer}} (inclusive of applicable
                            taxes)of the Total Withdrawable Amount (as
                            per the repayment schedule) on the date of levy
                            of such charges during initial tenure.</div>
                
                        <div><strong>Subsequent Tenure:</strong> {{pricingData.subsequentTenurePer}} (inclusive of
                            applicable taxes) of the Total Withdrawable
                            Amount (as per the repayment schedule) on the
                            date of levy of such charges during subsequent
                            tenure."</div>
                    </div>
                </div>
                <div class="pricing-details-text" *ngIf="pricingData.l4ProductTypeDesc === 'Bajaj Finance Term Loan(MFI)'">
                    <div>As per RBI Direction on Microfinance Loans dated March 14, 2022 effective April 01, 2022 your loan is classified as microfinance loan due to which there will be no prepayment and foreclosure charges levied on the same.</div>
                </div>
                <div class="pricing-details-text">
                    <div>EMI mentioned above may vary basis date of disbursement.</div>
                </div>
                <div class="pricing-details-text">
                    <div>*Please note final approval is subject to our lending partner, any previous communication on commercial stands null and void.</div>
                </div>
                <div class="pricing-details-text">
                    <div>***First EMI Amount is inclusive of Broken Period Interest(BPI). BPI amount calculated considering today's date as the date of disbursement. In case customer avails disbursement at a different date, this amount may undergo a change with corresponding probable impact on Net disbursement and APR.</div>
                </div>
                <div class="button-section">
                    <button type="button" id="next" class="approve-btn w-50" (click)="approvePricing()">APPROVE</button>
                </div>
                <div class="pricing-section">
                    <div>T&C : <a href="https://www.bajajfinservmarkets.in/legal-and-compliance/credit-application-terms-and-conditions.html"  style="color: #0074c9">https://www.bajajfinservmarkets.in/legal-and-compliance/credit-application-terms-and-conditions.html</a></div>
                </div>
                <div class="pricing-section" style="padding-bottom: 20px;">
                    <div>Bajaj Markets</div>
                </div>
            </div>
        </div>

        <!-- <div style="margin-top: 30px;">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem class="slide row" *ngFor="let slide of imgUrlDetails">
                    <img src="{{ slide?.imageUrl }}" alt="">
                </div>
            </ngx-slick-carousel>
        </div> -->
    </div>
</div>
    
    <!-- </div>
</div> -->
